import React from 'react';
import {
  getPermissionByType,
  isUserPermissionValid
} from '@shared/utils/permissions';
import { MANAGEMENT_PERMISSIONS_SERVER } from '@shared/constants/permissions';

interface UserPermission {
  permissionName: string;
  permissionValue: string;
}

interface ManageUsersRoleCellTextProps {
  userPermissions: UserPermission[];
}

const permissionAbbreviations = {
  [MANAGEMENT_PERMISSIONS_SERVER.INVITE_USERS]: 'IU',
  [MANAGEMENT_PERMISSIONS_SERVER.PROJECT_VISIBILITY]: 'PS',
  [MANAGEMENT_PERMISSIONS_SERVER.MODEL_REGISTRY]: 'MR'
};

const ManageUsersRoleCellText = ({
  userPermissions = []
}: ManageUsersRoleCellTextProps) => {
  if (
    isUserPermissionValid(
      getPermissionByType(
        userPermissions,
        MANAGEMENT_PERMISSIONS_SERVER.MANAGEMENT
      )
    )
  ) {
    return 'Workspace owner';
  }

  const text = 'Workspace member';

  const additionalText = Object.entries(permissionAbbreviations)
    .filter(([permissionType]) =>
      isUserPermissionValid(
        getPermissionByType(userPermissions, permissionType)
      )
    )
    .map(([, abbreviation]) => abbreviation);

  return (
    <span>
      {`${text}${
        additionalText.length ? ` (${additionalText.join(', ')})` : ''
      }`}
    </span>
  );
};

export default ManageUsersRoleCellText;
